export default __webpack_public_path__ + "static/water-mob-a0813dd91325172c1a583d2aa3d4d535.gif";